<script>
import Badge from "@/components/atoms/badge";
import Button from "@/components/atoms/button";
import Alert from "@/components/molecules/alert";
import CmsFetcher from "@/containers/cms-fetcher";
import Popin from "@/containers/popin-adaptive";

export default {
  name: "FideliteMerchNew",
  components: {
    Alert,
    Badge,
    Button,
    CmsFetcher,
    Popin
  },
  props: {}
};
</script>
<template>
  <Alert
    variant="white"
    outline="new"
    padding="xs25"
    outline-size="2"
    radius="md"
  >
    <div class="u-flex u-flex-align-center">
      <Badge
        size="md"
        variant="new"
        radius="md"
        class="u-px-xs u-py-xxs u-mr-xs25 u-font-500 u-font-16 u-color-white"
      >
        Nouveau
      </Badge>
      <div class="u-flex u-flex-grow u-block@md">
        <p class="u-font-700 u-font-16 u-color-new">
          Votre programme de fidélité évolue
        </p>
        <Button
          link
          class="u-ml-auto u-ml-none@md"
          @click="$refs.infoPopin.show()"
        >
          En savoir plus
        </Button>
      </div>
    </div>
    <Popin
      ref="infoPopin"
      aria-label="plus d'infos"
      size="lg"
    >
      <CmsFetcher link="/infos-et-services/pages-cachees/fidelite-pop-in-explicative-transition" />
      <div class="u-flex u-flex-justify-center">
        <Button
          variant="primary"
          size="md"
          radius="full"
          class="u-m-sm"
          outline
          @click="$refs.infoPopin.hide()"
        >
          Fermer
        </Button>
      </div>
    </Popin>
  </Alert>
</template>
<style lang="scss" scoped>
</style>
